<template>
  <el-dialog
    :title="$t('text.please_select_an_organisation')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="400px"
  >
    <div class="organisation-selection-wrapper">
      <el-radio-group v-model="selectedOrganisation">
        <el-radio
          v-for="organisation in organisations"
          :key="organisation.OrganisationName.OrganisationId"
          class="organisation-selection-item"
          :label="organisation.OrganisationName.OrganisationId"
          >{{ organisation.OrganisationName.Name }}</el-radio
        >
      </el-radio-group>
    </div>
    <div slot="footer" class="text-right">
      <el-button
        class="save-btn min-w-80"
        @click="setPermission()"
        :loading="loading"
        >{{ $t('text.ok').toUpperCase() }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      selectedOrganisation: null,
      loading: false
    }
  },
  props: {
    organisations: {
      type: Array
    }
  },
  mounted() {
    this.selectedOrganisation = this.$store.getters[
      `user/selecteOrganisationId`
    ]
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    setPermission() {
      if (!this.selectedOrganisation) {
        let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
        this.$confirm(
          `<div class='warning-content'>${this.$t(
            'text.please_select_an_organisation'
          )}.</div>` + `<img class='warning-icon' src=${warningIconUrl}>`,
          this.$t('text.warning'),
          {
            confirmButtonText: this.$t('text.ok').toUpperCase(),
            confirmButtonClass: 'confirm-btn',
            type: 'warning',
            customClass: 'delete-warning-box',
            showClose: true,
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true,
            showCancelButton: false
          }
        )
        return false
      }
      this.handleSetPermission()
    },
    handleSetPermission() {
      let organisation = this.organisations.filter(organisation => {
        return (
          organisation.OrganisationName.OrganisationId ===
          this.selectedOrganisation
        )
      })
      this.$store.dispatch('user/assignPermission', organisation[0])
      this.closeDialog()
      this.$emit('assignPermissionSuccess')
    }
  }
}
</script>

<style lang="scss" scoped>
.organisation-selection-wrapper::v-deep {
  border: 1px solid #ebeef5;
  border-radius: 5px;
  .el-radio-group {
    width: 100%;
    .el-radio {
      display: block;
      width: 100%;
      margin-bottom: 0 !important;
    }
  }
  .organisation-selection-item {
    padding: 10px;
    cursor: pointer;
    text-align: left;
    &:not(:last-child) {
      border-bottom: 1px solid #ebeef5;
    }
    &.is-checked {
      background: rgba(152, 193, 217, 1);
      .el-radio__label {
        color: white;
      }
      .el-radio__input.is-checked .el-radio__inner {
        border-color: white;
        background-color: rgba(152, 193, 217, 1);
      }
    }
  }
}
</style>
